import { useEffect, type ReactNode } from 'react';
import SessionStore from 'stores/shared/session';
import { loadLocales } from 'services/translation';

import { resolveTourHeaderLocale, type TourHeaderProps } from './helpers';
import {
  BrandedHeaderLink,
  BrandedHeaderLogo,
  BrandedTourHeader,
  RoundUserLogo,
  RoundUserLogoImage,
} from './styles';

const renderAvatar = (avatarUrl: string, altText: string) => (
  <RoundUserLogo>
    <RoundUserLogoImage src={avatarUrl} alt={altText} />
  </RoundUserLogo>
);

const buildTourHeaderContent = ({
  avatar_url,
  display_name,
  guide_website_url,
  linkable_header,
  logo,
}: TourHeaderProps): ReactNode => {
  if (logo) {
    return <BrandedHeaderLogo src={logo} alt={display_name} />;
  }

  if (avatar_url) {
    return (
      <>
        {renderAvatar(avatar_url, display_name)}
        {display_name}
      </>
    );
  }

  if (linkable_header && guide_website_url) {
    return (
      <BrandedHeaderLink href={guide_website_url}>
        {display_name}
      </BrandedHeaderLink>
    );
  }

  return display_name;
};

export const TourHeader = (props: TourHeaderProps) => {
  const { color, i18n_locale, tour } = props;

  useEffect(() => {
    const locale = resolveTourHeaderLocale({ tour, i18n_locale });
    loadLocales(SessionStore.state.get('i18n') || locale);
  }, [tour, i18n_locale]);

  return (
    <BrandedTourHeader backgroundColor={color ?? undefined}>
      {buildTourHeaderContent(props)}
    </BrandedTourHeader>
  );
};

export default TourHeader;
